<ion-content class="splash-screen">
  <div class="splash-content">
    <ngx-slick-carousel *ngIf="slickAvailable" class="splash-screen__carousel"  (afterChange)="onAfterChange($event)" #slickModal="slick-carousel" [config]="slideConfig">
      <div class="ion-wrap" ngxSlickItem>
        <div class="splash-slide-content">
          <img src="../../../assets/splash/splash-img-1.svg" alt="splash1">   
        </div>
      </div>       
      <div class="ion-wrap" ngxSlickItem>
        <div class="splash-slide-content">
          <img src="../../../assets/splash/splash-img-4.svg" alt="splash1">       
        </div>
      </div>
      <div class="ion-wrap" ngxSlickItem>
        <div class="splash-slide-content">
          <img src="../../../assets/splash/splash-img-3.svg" alt="splash1">       
        </div>
      </div>
      <div class="ion-wrap" ngxSlickItem>
        <div class="splash-slide-content">
          <img src="../../../assets/splash/splash-img-2.svg" alt="splash1">        
        </div>
      </div>
    </ngx-slick-carousel>
    <div *ngIf="!slickAvailable" class="splash-slide-content">
      <img [src]="'../../../assets/splash/splash-img-' + (index === 0 ? 1 : index === 1 ? 4 : index === 2 ? 3 : 2) + '.svg'" alt="splash">
    </div>
    <h2 class="splash-screen__title">{{'SPLASH.TITLE_'+index | translate}}</h2>
    <p class="splash-screen__text">
      {{'SPLASH.TEXT_'+index | translate}}
    </p>
    <div class="splash-screen__btns">
      <button  class="btn-skip" (click)="finish()">{{'SPLASH.SKIP' | translate}}</button>
      <button class="btn-next" (click)="goNext()">{{index == 3 ? ('SPLASH.END' | translate) : ('SPLASH.NEXT' | translate)}}</button>
    </div>
  </div>
  <div class="splash-overlay" [class.hidden]="loaded"></div>
</ion-content>
